import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import usePageMeta from "@/lib/usePageMeta";

export default function Login() {
  usePageMeta({ title: "Admin", noindex: true });
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Velkommen tilbage.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login mislykkedes.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-background" data-testid="admin-login-page">
      <div className="hidden md:block relative">
        <img src="/images/skovvej-8.webp" alt="" className="img-cover" />
        <div className="absolute inset-0 bg-black/30" />
        <span className="absolute bottom-10 left-10 font-display text-3xl tracking-[0.3em] text-white">HAGELUND</span>
      </div>
      <div className="flex items-center justify-center px-6 py-20">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <p className="text-xs uppercase tracking-label text-accent mb-4">Administration</p>
          <h1 className="font-display text-5xl font-light mb-10">Log ind</h1>
          <div className="space-y-6">
            <div>
              <label className="block text-xs uppercase tracking-label mb-2 text-muted-foreground">E-mail</label>
              <input
                data-testid="admin-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border-b border-border py-3 outline-none focus:border-foreground transition-colors"
                placeholder="admin@hagelund-aps.dk"
              />
            </div>
            <div>
              <label className="block text-xs uppercase tracking-label mb-2 text-muted-foreground">Adgangskode</label>
              <input
                data-testid="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-transparent border-b border-border py-3 outline-none focus:border-foreground transition-colors"
                placeholder="••••••••"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="group mt-10 inline-flex items-center gap-3 bg-foreground text-background px-8 py-4 text-xs uppercase tracking-label font-semibold hover:bg-accent transition-colors disabled:opacity-50"
          >
            {loading ? "Logger ind..." : "Log ind"}
            <ArrowRight size={16} weight="bold" className="transition-transform group-hover:translate-x-1" />
          </button>
        </form>
      </div>
    </div>
  );
}
